module.exports = __webpack_public_path__ + "static/media/hall-CSA.0282711d.svg";